import { Control, UseFormSetValue } from 'react-hook-form';
import Input from 'components/Common/Input';
import { Typography, Button, Paper, CircularProgress, useTheme } from '@mui/material';
import { FaChevronRight } from 'react-icons/fa';
import { normalizeWebsiteUrl } from '@/utils/helperFunctions';

interface StepProps {
  onNext: () => void | Promise<void>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  isSubmitting?: boolean;
}

const WebsiteStep: React.FC<StepProps> = ({ onNext, control, setValue, isSubmitting = false }: StepProps) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 3, borderRadius: 3, width: '100%' }}>
      <Typography fontWeight={600} sx={{ fontSize: { xs: '16px', md: '24px' } }}>
        What's your business website?
      </Typography>

      <Typography lineHeight='normal' fontSize='14px' color='text.secondary' mt={1} mb={1}>
        We'll scan your website to pre-fill your business details and train your AI agent faster.
      </Typography>

      <Input
        name='website_url'
        control={control}
        fullWidth
        label='Business Website'
        margin='normal'
        placeholder='https://example.com'
        onBlurCapture={(event: React.FocusEvent<HTMLInputElement>) => {
          const normalizedUrl = normalizeWebsiteUrl((event.target as HTMLInputElement).value);
          setValue('website_url', normalizedUrl, {
            shouldDirty: true,
            shouldValidate: true
          });
        }}
      />

      <Typography variant='body2' color='text.secondary' mt={0.5}>
        Don't have a website? No worries — just skip this.
      </Typography>

      <Button
        variant='contained'
        fullWidth
        disabled={isSubmitting}
        sx={{
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          background: theme.palette.primary.main,
          mt: 3
        }}
        onClick={onNext}
      >
        {isSubmitting ? (
          <CircularProgress size={20} color='inherit' />
        ) : (
          <>
            Continue <FaChevronRight />
          </>
        )}
      </Button>
    </Paper>
  );
};

export default WebsiteStep;
